'use strict';

module.exports = function (password) {
    const regex =
        /^(?=.*?[0-9])(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[!-/:-@[-`{-~])[0-9a-zA-Z!-/:-@[-`{-~]{8,12}$/;
    return regex.test(password);
};
